import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23.098",
  height: "8.491"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F59600",
  d: "M4.053 0 0 4.246l4.053 4.245L5.27 7.216 3.296 5.147h6.531v-1.8H3.296L5.27 1.279zm14.993 0-1.218 1.279 1.974 2.068h-6.531v1.8h6.531l-1.974 2.068 1.217 1.275 4.053-4.245z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };